import styled from 'styled-components';

const StyledDiv = styled.div`
    display: flex;
    justify-content: end;
`;

export default StyledDiv;
